import MichalZakrzewski from "../../../../images/content/introduction/applia-secretariat/MichalZakrzewski.webp";
import AlexandraMaxheleau from "../../../../images/content/introduction/applia-secretariat/AlexandraMaxheleau.webp";
import IuliaMariaFlorea from "../../../../images/content/introduction/applia-secretariat/IuliaMariaFlorea.webp";

export const AppliaSecretariatMembersTeam6 = [
	{
		name: "Michał Zakrzewski",
		imageUrl: MichalZakrzewski,
		background: "pages.introduction.appliaSecretariat.members.michalZakrzewski.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.michalZakrzewski.functionTitle",
	},
	{
		name: "Alexandra Maxheleau",
		imageUrl: AlexandraMaxheleau,
		background: "pages.introduction.appliaSecretariat.members.alexandraMaxheleau.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.alexandraMaxheleau.functionTitle",
	},
	{
		name: "Iulia Maria Florea",
		imageUrl: IuliaMariaFlorea,
		background: "pages.introduction.appliaSecretariat.members.iuliaMariaFlorea.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.iuliaMariaFlorea.functionTitle",
	},
];
